import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    currentStep: 1,

    selectedCity: '',
    address: '',
    street: '',
    buildingNumber: '',
    entrance: '',
    apartment: '',
    floor: '',
    intercomCode: '',
    postalCode: '',
    isPrivateHouse: false,
    latitude: null,
    longitude: null,
    placeId: '',
    isServiceable: false,
    serviceabilityError: '',

    service_package: {},
    request_files: [],

    finalPrice: 0,
    request_price: null,
    // Promotion ("Акція") applied at checkout. promo_code is sent with the
    // order; the discount itself is applied server-side (authoritative).
    // promo_discount_percent is kept only to show the discounted total.
    promo_code: null,
    promo_discount_percent: null,
    services: [],
    typeBuilding: '',
    type_cleaning: '',
    countPanoramicWindows: null,
    countOrdinaryWindows: null,
    countRooms: null,
    countBathrooms: null,
    squareApartment: null,
    selectedDate: null,
    selectedTime: null,
    request_datetime: null,
    accessToApartment: '',
    locationAccessToApartment: '',
    comment: '',
    regularUserInfo: {
        email: '',
        password: '',
    },
    newUserInfo: {
        surname: '',
        name: '',
        email: '',
        phone: '',
        password: '',
        repeatPassword: '',
        comment: '',
    },
    offeredPrice: null,
    selectedFiles: [],
    dateCreationOrder: null,
    typeSorting: '',
    selectedBank: ''
}

const stepperInfoSlice = createSlice({
    name: 'stepperInfoSlice',
    initialState,
    reducers: {
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },

        setSelectedCity: (state, action) => {
            state.selectedCity = action.payload;
        },
        setAddress: (state, action) => {
            state.address = action.payload;
        },
        setFloor: (state, action) => {
            state.floor = action.payload;
        },
        setIntercomCode: (state, action) => {
            state.intercomCode = action.payload;
        },
        setPostalCode: (state, action) => {
            state.postalCode = action.payload;
        },
        setIsPrivateHouse: (state, action) => {
            state.isPrivateHouse = action.payload;
        },
        setLatitude: (state, action) => {
            state.latitude = action.payload;
        },
        setLongitude: (state, action) => {
            state.longitude = action.payload;
        },
        setPlaceId: (state, action) => {
            state.placeId = action.payload;
        },
        setIsServiceable: (state, action) => {
            state.isServiceable = action.payload;
        },
        setServiceabilityError: (state, action) => {
            state.serviceabilityError = action.payload;
        },
        setRequestFiles: (state, action) => {
            state.request_files = action.payload;
        },

        setStreet: (state, action) => {
            state.street = action.payload;
        },
        setBuildingNumber: (state, action) => {
            state.buildingNumber = action.payload;
        },
        setEntrance: (state, action) => {
            state.entrance = action.payload;
        },
        setApartment: (state, action) => {
            state.apartment = action.payload;
        },

        setServicePackage: (state, action) => {
            const {price} = action.payload;

            state.service_package = action.payload;

            const totalPriceForAdditionalServices = state.services.reduce((price, item) => price + item.price, 0);
            const finalPrice = price + totalPriceForAdditionalServices;

            state.finalPrice = finalPrice;
        },
        setFinalPrice: (state, action) => {

        },
        setRequestPrice: (state, action) => {
            state.request_price = action.payload;
        },
        // Store / clear the promo applied at checkout. payload:
        // {promo_code, discount_percent} when applied, null/{} to clear.
        setAppliedPromo: (state, action) => {
            const {promo_code = null, discount_percent = null} = action.payload || {};
            state.promo_code = promo_code;
            state.promo_discount_percent = discount_percent;
        },
        addService: (state, action) => {
            // state.additionalServices.push(action.payload);
            //
            // const totalPriceForAdditionalServices = state.additionalServices.reduce((price, item) => price + +item.price, 0);
            // const price = +state.selectedPackage.price + +totalPriceForAdditionalServices;
            //
            // state.finalPrice = price;
            state.services.push(action.payload);

            const totalPriceForAdditionalServices = state.services.reduce((price, item) => price + item.price, 0);
            const finalPrice = +state.service_package.price + totalPriceForAdditionalServices;
            state.finalPrice = finalPrice;
        },
        removeService: (state, action) => {
            const {id} = action.payload;

            state.services = state.services.filter(item => item.id !== id);

            const totalPriceForAdditionalServices = state.services.reduce((price, item) => price + item.price, 0);
            const finalPrice = +state.service_package.price + totalPriceForAdditionalServices;

            state.finalPrice = finalPrice;
        },
        removeAllServices: (state, action) => {
            state.services = [];
        },
        setTypeBuilding: (state, action) => {
            state.typeBuilding = action.payload;
        },
        setTypeCleaning: (state, action) => {
            state.type_cleaning = action.payload;
        },
        setCountPanoramicWindows: (state, action) => {
            state.countPanoramicWindows = action.payload;
        },
        setCountOrdinaryWindows: (state, action) => {
            state.countOrdinaryWindows = action.payload;
        },
        setCountRooms: (state, action) => {
            state.countRooms = action.payload;
        },
        setCountBathrooms: (state, action) => {
            state.countBathrooms = action.payload;
        },
        setSquareApartment: (state, action) => {
            state.squareApartment = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        },
        setSelectedTime: (state, action) => {
            state.selectedTime = action.payload;
        },
        setRequestDateTime: (state, action) => {
            state.request_datetime = action.payload;
        },
        setAccessToApartment: (state, action) => {
            state.accessToApartment = action.payload;
        },
        setLocationAccessToApartment: (state, action) => {
            state.locationAccessToApartment = action.payload;
        },
        setComment: (state, action) => {
            state.comment = action.payload;
        },
        setRegularUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setNewUserInfo: (state, action) => {
            state.newUserInfo = action.payload;
        },
        setOfferedPrice: (state, action) => {
            state.offeredPrice = action.payload;
        },
        setSelectedFiles: (state, action) => {
            state.selectedFiles = action.payload;
        },
        setTypeSorting: (state, action) => {
            state.typeSorting = action.payload;
        },
        setSelectedBank: (state, action) => {
            state.selectedBank = action.payload;
        },

        clearAllData: (state) => {
            state.selectedCity = '';
            state.address = '';
            state.street = '';
            state.buildingNumber = '';
            state.entrance = '';
            state.apartment = '';
            state.floor = '';
            state.intercomCode = '';
            state.postalCode = '';
            state.isPrivateHouse = false;
            state.latitude = null;
            state.longitude = null;
            state.placeId = '';
            state.isServiceable = false;
            state.serviceabilityError = '';
            state.selectedPackage = {
                packageName: '',
                packagePrice: null,
            };
            state.finalPrice = 0;
            state.additionalServices = [];
            state.typeBuilding = '';
            state.type_cleaning = '';
            state.countPanoramicWindows = null;
            state.countOrdinaryWindows = null;
            state.countRooms = null;
            state.countBathrooms = null;
            state.squareApartment = null;
            state.selectedDate = null;
            state.selectedTime = null;
            state.accessToApartment = '';
            state.locationAccessToApartment = '';
            state.comment = '';
            state.services = [];
            state.request_files = [];
            state.request_datetime = null;
            state.request_price = null;
            state.promo_code = null;
            state.promo_discount_percent = null;
            state.service_package = {};
            state.regularUserInfo = {
                email: '',
                password: '',
            };
            state.newUserInfo = {
                surname: '',
                name: '',
                email: '',
                phone: '',
                password: '',
                repeatPassword: '',
                comment: '',
            };
            state.offeredPrice = null;
            state.selectedFiles = [];
            state.dateCreationOrde = null;
            state.typeSorting = '';
            state.selectedBank = '';
        }
    }
})

const {actions, reducer: stepperInfoReducer} = stepperInfoSlice;

const stepperInfoActions = {
    ...actions,
}

export {
    stepperInfoActions,
    stepperInfoReducer,
}
